module.exports = __webpack_public_path__ + "img/title6.9d2aab88.png";